export const ID_CREDENCIAL_ELECTOR = 6;
